import { createContext } from 'react';

// Shared TrackContext for app-wide track visibility state
const TrackContext = createContext({});

export default TrackContext;
